import { useContext, useEffect } from 'react';
import env from 'env/.public-env.json';
import DatasetDefinitionsContext from '../../../contexts/DatasetDefinitionsContext';

/**
 * On boards against bonus datasets, we want to get the rewards API
 * ready for requests once a user opens up the board.
 *
 * This API is in a cloud function which will go to sleep after a period
 * of not being used.
 */
const useDriverRewardOutputWakeupCall = (
  board: PerformanceBoardTypes.Board,
) => {
  const { getBonusProgram } = useContext(DatasetDefinitionsContext);

  useEffect(() => {
    const bonusProgram = getBonusProgram(board.dataType);
    if (!bonusProgram) {
      return;
    }

    const baseUrl = env.USE_LOCAL_FUNCTIONS
      ? `http://localhost:5000/${env.PROJECT_ID}/us-east4`
      : env.API_GATEWAY_URL;
    fetch(`${baseUrl}/v1/driver_bonus/rewards`, {
      method: 'OPTIONS',
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch(() => {
      // Only a wake-up: the board's real requests report their own failures
    });
  }, [board.dataType, getBonusProgram]);
};

export default useDriverRewardOutputWakeupCall;
